/* This file is generated by Kubb. DO NOT EDIT MANUALLY. */

import type { DeleteAccountWebpushMutationRequest } from './types/DeleteAccountWebpush.ts';
import type { PostAccountLanguageMutationRequest } from './types/PostAccountLanguage.ts';
import type { PostAccountWebpushMutationRequest } from './types/PostAccountWebpush.ts';
import type { Client } from '@kubb/plugin-client/clients/fetch';
import { deleteAccountWebpush } from './clients/deleteAccountWebpush.ts';
import { getAccount } from './clients/getAccount.ts';
import { getAccountLanguage } from './clients/getAccountLanguage.ts';
import { postAccountLanguage } from './clients/postAccountLanguage.ts';
import { postAccountWebpush } from './clients/postAccountWebpush.ts';

export class ApiClient {
  constructor(private readonly client: Client) {}

  getAccount() {
    return getAccount({ client: this.client });
  }
  postAccountWebpush(data: PostAccountWebpushMutationRequest) {
    return postAccountWebpush(data, { client: this.client });
  }
  deleteAccountWebpush(data: DeleteAccountWebpushMutationRequest) {
    return deleteAccountWebpush(data, { client: this.client });
  }
  getAccountLanguage() {
    return getAccountLanguage({ client: this.client });
  }
  postAccountLanguage(data: PostAccountLanguageMutationRequest) {
    return postAccountLanguage(data, { client: this.client });
  }
}
